/* A section can be replaced at any time by Shopify's visual editor. */
if (!customElements.get('solstice-collection-cards')) {
  customElements.define('solstice-collection-cards', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      this.abort = new AbortController();
      const {signal} = this.abort;
      const track = this.querySelector('.banner-slider');
      if (!track) return;
      const slides = [...track.querySelectorAll('.mega-slide-wrapper')];
      const dots = this.querySelector('[data-dots]');
      const previous = this.querySelector('[data-previous]');
      const next = this.querySelector('[data-next]');
      if (!dots || !previous || !next) {
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => {
          if (this.isConnected) this.connectedCallback();
        }, {once:true, signal});
        return;
      }
      dots.replaceChildren();
      const offset = slide => slide.offsetLeft - slides[0].offsetLeft;
      const go = index => track.scrollTo({left: offset(slides[index]), behavior: 'smooth'});
      const current = () => slides.reduce((best, slide, index) => Math.abs(offset(slide)-track.scrollLeft) < Math.abs(offset(slides[best])-track.scrollLeft) ? index : best, 0);
      slides.forEach((slide, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'dot';
        dot.setAttribute('aria-label', (this.dataset.collectionLabel || '__INDEX__').replace('__INDEX__', String(index + 1)));
        dot.addEventListener('click', () => go(index), {signal});
        dots.append(dot);
      });
      const update = () => {
        const active = slides.length ? current() : 0;
        [...dots.children].forEach((dot, index) => {
          dot.classList.toggle('is-active', index === active);
          dot.setAttribute('aria-current', index === active ? 'true' : 'false');
        });
        previous.classList.toggle('is-hidden', track.scrollLeft <= 5);
        next.classList.toggle('is-hidden', track.scrollLeft + track.clientWidth >= track.scrollWidth - 5);
      };
      previous.addEventListener('click', () => {if(slides.length) go(Math.max(0, current()-1));}, {signal});
      next.addEventListener('click', () => {if(slides.length) go(Math.min(slides.length-1, current()+1));}, {signal});
      track.addEventListener('scroll', update, {passive:true, signal});
      this.addEventListener('shopify:block:select', event => {
        const index = slides.findIndex(slide => slide === event.target || slide.contains(event.target));
        if(index >= 0) go(index);
      }, {signal});
      this.resize = new ResizeObserver(update);
      this.resize.observe(track);
      update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
    }
  });
}
